<template>
  <v-card class="elevation-12 mt-3 mx-1" :loading="loading">
    <v-toolbar color="primary" dark flat>
      {{ pageTitle }}
    </v-toolbar>

    <v-card-text v-if="isPrintPackageLoaded">
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
          <tr>
            <th>№</th>
            <th>Идентификатор</th>
            <th>Получатель</th>
            <th>Область</th>
            <th>Район</th>
            <th>Адрес</th>
            <th>Дата поступления</th>
            <th>Пост пакет</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="mail in displayMails" :key="mail.id" :class="{
                        'white--text black': mail.isPerformedNotTry,
                        'green lighten-4': !mail.isPerformedNotTry && mail.isPacked,
                        'light-blue lighten-4': !mail.isPerformedNotTry && !mail.isPacked && mail.isPrinted
                    }">
            <td>{{ mail.displayNumber }}</td>
            <td>
              <router-link :to="{name: 'mail', params:{uid: mail.uid}}">
                {{ mail.uid }}
              </router-link>
            </td>
            <td>{{ mail.receiver }}</td>
            <td>{{ mail.region.name }}</td>
            <td>{{ mail.area.name }}</td>
            <td>{{ mail.address }}</td>
            <td class="text-center">
              {{ mail.createdOn.format('DD.MM.YYYY') }}
              <br>
              {{ mail.createdOn.format('HH:mm:ss') }}
            </td>
            <td>
              <template v-if="mail.postPackage">
                <router-link :to="{name: 'post-package', params: {uid: mail.postPackage.uid}}">{{
                    mail.postPackage.uid
                  }}
                </router-link>
              </template>
            </td>
            <td class="text-right">
              <v-btn @click="onReprintMailButtonClicked(mail)" color="primary" x-small>Распечатать письмо</v-btn>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>

    <v-card-actions>
      <v-spacer/>
      <span>Писем: {{ mailsCount }}</span>
      <span class="ml-3">Листов: {{ mailsPagesSum }}</span>
      <v-spacer/>
      <v-btn color="warning" small @click="onReprintButtonClicked">Распечатать ещё раз</v-btn>
    </v-card-actions>

    <v-snackbar v-model="isMailsLoadingFailed"
                :timeout="5000"
                :top="true"
                color="error"
    >
      Не удалось загрузить письма
    </v-snackbar>
    <v-snackbar v-model="isPrintPackageLoadingFailed"
                :timeout="5000"
                :top="true"
                color="error"
    >
      Не удалось загрузить печатный реестр
    </v-snackbar>
  </v-card>
</template>

<script>
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP, LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";
import PrintPackageService from '@/services/print.package.service'
import MailService from '@/services/mail.service'
import Mappers from '@/mappers'
import _ from 'underscore'
import PrintJS from "print-js";

export default {
  name: "PrintPackageView",
  data() {
    return {
      printPackage: null,
      mails: [],
      loading: false,
      isMailsLoadingFailed: false,
      isPrintPackageLoadingFailed: false
    }
  },
  computed: {
    pageTitle() {
      let title = 'Печатный реестр'
      if (this.printPackage)
        title = `${title} : ${this.printPackage.uid}`

      return title
    },
    isPrintPackageLoaded() {
      return !!this.printPackage
    },
    mailsCount() {
      return this.mails.length
    },
    mailsPagesSum() {
      let sum = 0
      _.each(this.mails, m => {
        sum += m.pagesCount
      })

      return sum
    },
    displayMails() {
      let number = 1;
      return _.map(this.mails, m => {
        m.displayNumber = number++
        return m
      })
    }
  },
  methods: {
    loadPrintPackage() {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)

      this.printPackage = null
      const uid = this.$route.params.uid

      this.isPrintPackageLoadingFailed = false
      PrintPackageService.get(uid)
          .then(response => {
            this.printPackage = Mappers.mapPrintPackage(response.data)
            this.setPageTitle()

            this.loadMails()
          })
          .catch(() => {
            this.isPrintPackageLoadingFailed = true
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    loadMails() {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)
      this.isMailsLoadingFailed = false

      PrintPackageService.getMails(this.printPackage.uid)
          .then(response => {
            this.mails = _.map(response.data, mailViewModel => {
              return Mappers.mapMail(mailViewModel)
            })
          })
          .catch(() => {
            this.isMailsLoadingFailed = true
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    setPageTitle() {
      this.$store.dispatch(LAYOUT_TITLE_CHANGED, this.pageTitle)
    },

    onReprintButtonClicked() {
      const path = PrintPackageService.getPdfPath(this.printPackage)

      PrintJS({printable: path, type: 'pdf', showModal: true, modalMessage: 'Подождите, идет загрузка для печати'})
    },
    onReprintMailButtonClicked(mail) {
      const path = MailService.getPdfPath(mail)

      PrintJS({printable: path, type: 'pdf', showModal: true, modalMessage: 'Подождите, идет загрузка для печати'})
    }
  },
  created() {
    this.setPageTitle()
    this.loadPrintPackage()
  },
  watch: {
    "$route": function () {
      this.loadPrintPackage()
    }
  },
}
</script>

<style scoped>
.white--text a {
  color: #ffffff;
  text-decoration: none;
}
</style>